import React from 'react';
import "./for_donors.css"
import Header from "../components/Header";
import Footer from "../components/Footer";
import waves_bg from "../MainPage/images/waves_bg.svg";
import FaqItem from "../MainPage/components/FaqItem";
import {motion} from "framer-motion";
import main_block_bg from "../MainPage/images/main_page_bg.svg";
import first_main_img from "./images/first_donors_banner.png";
import second_main_img from "./images/second_donors_banner.png";
import third_main_img from "./images/third_main_image.png";
import fourth_main_img from "./images/fourth_main_image.png";
import real_impact_icon1 from "./images/real_impact_icon1.svg";
import real_impact_icon2 from "./images/real_impact_icon2.svg";
import real_impact_icon3 from "./images/real_impact_icon3.svg";
import your_impact from "./images/your_impact_img.png";
import gal_blue from "./images/gal_blue.svg";
import gal_trust from "./images/trust_donors_gal.svg";
import right_trust from "./images/right_bg_trust_donors.svg";
import left_trust from "./images/left_bg_trust_donors.svg";
import blue_star from "./images/blue_star.svg";
import circles_bg from "./images/circles.svg";
import ProjectCard from "../MainPage/components/ProjectCard";
import {Link} from "react-scroll";
import DevelopmentButton from "../components/DevelopmentButton";

const ForDonors = () => {

    const initial = {opacity: 0, y: 40}
    const whileInView = {opacity: 1, y: 0}
    const transition = {duration: 0.8, ease: "easeOut", delay: 0.1}
    const viewport = {once: true, amount: 0.3}

    const motionProps = {
        initial,
        whileInView,
        transition,
        viewport
    };

    const faq_items = [{
        question: "How does UNDURA verify projects?",
        answer: "Each project is verified through our KYB process and partnership checks.\n" +
            "We only list organizations with transparent records and verified payment accounts.\n" +
            "You can also find detailed information and verification status in each project’s description."
    }, {
        question: "Can I get a tax deduction?",
        answer: "Tax deductions depend on the organization’s legal status and your country’s tax laws. Registered charities on Undura Lite can issue donation receipts that donors may use for tax purposes."
    }, {
        question: "How can I track the results?",
        answer: "You’ll get updates and reports directly from the organization in your donor dashboard."
    }, {
        question: "What payment methods are supported?",
        answer: "Donations are processed securely via Stripe — credit card, Apple Pay, and Google Pay."
    }, {
        question: "Are there limits on the donation amount?",
        answer: "There’s no minimum.\n" +
            "For donations above €300, identity verification may be requested for security reasons."
    }]
    const motionPropsHeader = {
        initial: {opacity: 0, y: -50},
        animate: {opacity: 1, y: 0},
        transition: {duration: 1, ease: "easeOut"},
    };

    const motionPropsMainBlock = {
        initial: {opacity: 0, y: 40},
        whileInView: {opacity: 1, y: 0},
        viewport: {once: true, amount: 0.3},
        transition: {duration: 0.8, ease: "easeOut"},
    };

    const bannerVariants = {
        hidden: {opacity: 0},
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                when: "beforeChildren",
            },
        },
    };

    const bannerItemVariants = {
        hidden: {opacity: 0, y: 30, scale: 0.95},
        visible: {opacity: 1, y: 0, scale: 1, transition: {duration: 0.8, ease: "easeOut"}},
    };

    const staggerContainer = {
        hidden: {},
        visible: {
            transition: {
                staggerChildren: 0.2,
            },
        },
    };

    const fadeUpItem = {
        hidden: {opacity: 0, y: 30},
        visible: {opacity: 1, y: 0, transition: {duration: 0.7, ease: "easeOut"}},
    };

    const pointVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.15, duration: 0.6, ease: "easeOut" }
        })
    };
    const fadeNumeric = {
        initial: "hidden",
        whileInView: "visible",
        viewport: {once: true},
        variants: pointVariants
    };


    const fadeDown = {
        initial: {opacity: 0, y: -40},
        whileInView: {opacity: 1, y: 0},
        viewport: {once: true, amount: 0.3},
        transition: {duration: 0.8, ease: "easeOut"}
    };

    const fadeLeft = {
        initial: {opacity: 0, x: -50},
        whileInView: {opacity: 1, x: 0},
        viewport: {once: true, amount: 0.3},
        transition: {duration: 0.8, ease: "easeOut"}
    };
    const fadeRight = {
        initial: {opacity: 0, x: 50},
        whileInView: {opacity: 1, x: 0},
        viewport: {once: true, amount: 0.3},
        transition: {duration: 0.8, ease: "easeOut"}
    };

    const hoverButton = {
        whileHover: {
            scale: 1.05,
            transition: { type: "spring", stiffness: 300 }
        }
    };

    const fadeUp = {
        initial: { opacity: 0, y: 40 },
        whileInView: { opacity: 1, y: 0 },
        viewport: { once: true, amount: 0.3 },
        transition: { duration: 0.8, ease: "easeOut" }
    };

    const buttonAnimate = {
        initial:fadeUp.initial,
        whileInView:fadeUp.whileInView,
        viewport:fadeUp.viewport,
        transition:fadeUp.transition,
        whileHover:hoverButton.whileHover
    }

    return (
        <div className="for_donors_page">
            <motion.img
                src={main_block_bg}
                alt=""
                className="main_block_bg"
                {...fadeUp}
            />

            <Header/>

            {/* Основной блок */}
            <motion.div className="for_donors_main_block" {...motionPropsMainBlock}>
                <motion.div className="for_donors" {...fadeUp}>
                    <div className="circle"></div>
                    For Donors
                </motion.div>

                <motion.div className="main_block_text" {...motionPropsMainBlock}>
                    <motion.div className="main_text" {...fadeLeft}>
                        Every donation matters — with full transparency and real impact.
                    </motion.div>

                    <motion.div className="main_block_desc" {...fadeRight}>
                        <div className="main_desc">
                            Support verified projects, track real-time results, and see how your help changes lives.
                        </div>
                        <div className="main_block_buttons">
                            <motion.a
                                href="/platforms"
                                className="get_started"
                                {...buttonAnimate}
                            >
                                See projects
                            </motion.a>
                            <Link to="how_works"
                                  smooth={true}
                                  duration={500}
                                  offset={-200}
                                  spy={true}>
                                <motion.div className="explore_demo" {...buttonAnimate}>
                                    How it works
                                </motion.div>
                            </Link>
                        </div>
                    </motion.div>
                </motion.div>
            </motion.div>

            <motion.div
                className="for_donors_main_banner"
                variants={bannerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{once: true, amount: 0.3}}
            >
                <div className="for_donors_main_banner_inside">
                    {[first_main_img, second_main_img, third_main_img, fourth_main_img].map((img, idx) => (
                        <motion.img
                            key={idx}
                            src={img}
                            alt=""
                            className={`banner_img banner_img_${idx + 1}`}
                            {...fadeNumeric}
                            custom={idx}
                            whileHover={{scale: 1.03}}
                        />
                    ))}
                </div>
            </motion.div>
            <a id="how_works"></a>
            <motion.div className="main_text" {...fadeLeft}>
                How your donation makes<br/> <span>a real impact</span>
            </motion.div>


            <div className="technology_three_points">
                {[{
                    icon: real_impact_icon1,
                    title: "Choose a project",
                    desc: "Find a verified initiative that resonates with your values.",
                }, {
                    icon: real_impact_icon2,
                    title: "Make a donation",
                    desc: "Your contribution is processed securely and reaches the project directly.",
                }, {
                    icon: real_impact_icon3,
                    title: "Track the results",
                    desc: "Get updates and see the real impact of your support in your dashboard.",
                }].map((item, idx) => (
                    <motion.div key={idx} className="technology_point" {...fadeNumeric} custom={idx}>
                        <div className="technology_icon_block for_donors_impact">
                            <img src={item.icon} alt=""/>
                            <div className="point_number">0{idx + 1}</div>
                        </div>
                        <div className="problems_item_name">{item.title}</div>
                        <div className="problems_item_desc">{item.desc}</div>
                    </motion.div>
                ))}
            </div>


            <a href="/platforms">
                <motion.div className="show_more_button" {...buttonAnimate}>
                    See projects
                </motion.div>
            </a>

            <motion.div className="your_impact_number_block">
                <motion.div className="your_impact_number_text" {...fadeLeft}>
                    <div className="main_text">Your impact <span>in numbers</span></div>
                    <div className="your_impact_number_points">
                        {[
                            {icon: gal_blue, value: "$2.5M+", desc: "Funds raised"},
                            {icon: gal_blue, value: "150+", desc: "Supported projects"},
                            {icon: gal_blue, value: "25+", desc: "Partners joined"},
                            {icon: gal_blue, value: "5,200+", desc: "Active donors"},
                        ].map((point, idx) => (
                            <motion.div key={idx} className="your_impact_number_point" variants={fadeUpItem}>
                                <img src={point.icon} alt=""/>
                                <div className="impact_point_kol">{point.value}</div>
                                <div className="impact_point_desc">{point.desc}</div>
                            </motion.div>
                        ))}
                    </div>
                    <a href="/platforms">
                        <motion.div className="see_project_button" {...buttonAnimate}>
                            See projects
                        </motion.div>
                    </a>
                </motion.div>
                <motion.div className="your_impact_image" {...fadeRight}>
                    <img src={your_impact} alt=""/>
                </motion.div>
            </motion.div>

            {/*= <motion.div className="where_your_donations">
                <motion.div className="powered_by" {...fadeUp}>
                    <div className="circle"></div>
                    Powered by Undura Lite
                </motion.div>

                <motion.div className="main_text" {...fadeLeft}>
                    Where your donation<br/> <span>makes a difference </span>
                </motion.div>

                <motion.div className="project_examples" variants={staggerContainer}>
                    {[...Array(4)].map((_, idx) => (
                        <motion.div key={idx} {...fadeNumeric} custom={idx}><ProjectCard/></motion.div>
                    ))}
                </motion.div>

                <motion.div className="show_more_button" {...buttonAnimate}>
                    Show more
                </motion.div>
            </motion.div>*/}

            {/* Заголовок «Why donors trust UNDURA»
            <motion.div className="main_text" {...fadeUp} transition={{ delay: 0.1 }}>
                <span>Why donors trust</span><br /> UNDURA
            </motion.div>

            <motion.div
                className="why_donors_trust"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
            >
                <motion.div whileHover={{ scale: 1.05 }} transition={{ type: "spring", stiffness: 300 }}>
                    <img src={gal_trust} alt="" /> Verified projects
                </motion.div>
                <motion.div whileHover={{ scale: 1.05 }} transition={{ type: "spring", stiffness: 300 }}>
                    <img src={gal_trust} alt="" /> Transparent fund flow
                </motion.div>
                <motion.div whileHover={{ scale: 1.05 }} transition={{ type: "spring", stiffness: 300 }}>
                    <img src={gal_trust} alt="" /> Real-time updates
                </motion.div>
            </motion.div>
            {/* Отзывы доноров
            <motion.div
                className="donors_trust_full_width"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={{
                    hidden: {},
                    visible: {
                        transition: {
                            staggerChildren: 0.2
                        }
                    }
                }}
            >
                <motion.img src={left_trust} alt="" variants={{ hidden: { opacity: 0, x: -50 }, visible: { opacity: 1, x: 0, transition: { duration: 0.8 } } }} />

                <motion.div className="trust_donors_bg" variants={{ hidden: { opacity: 0 }, visible: { opacity: 1, transition: { duration: 0.8 } } }}>
                    <motion.div className="trust_donors_content" variants={{ hidden: {}, visible: { transition: { staggerChildren: 0.2 } } }}>
                        <motion.div className="stars_list" variants={{ hidden: { opacity: 0, scale: 0.8 }, visible: { opacity: 1, scale: 1, transition: { duration: 0.6 } } }}>
                            {[...Array(5)].map((_, i) => <img key={i} src={blue_star} alt="" />)}
                        </motion.div>

                        <motion.div className="review_main" variants={{ hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0, transition: { duration: 0.8 } } }}>
                            <div className="main_text_review">
                                Finally, I can see where my money goes. UNDURA has changed my approach to donations.
                            </div>
                            <div className="review_author">
                                <div className="review_author_name">Jenny Wilson</div>
                                <div className="review_author_donor">Donor</div>
                            </div>
                        </motion.div>
                    </motion.div>
                </motion.div>

                <motion.img src={right_trust} alt="" variants={{ hidden: { opacity: 0, x: 50 }, visible: { opacity: 1, x: 0, transition: { duration: 0.8 } } }} />
            </motion.div>
            */}

            <motion.div className="main_text" {...fadeLeft}>
                Questions you might have
            </motion.div>

            <motion.div className="faq_full" initial="hidden" whileInView="visible" viewport={{once: true, amount: 0.3}}
                        variants={{hidden: {}, visible: {transition: {staggerChildren: 0.15}}}}>
                <motion.div className="faq_main" variants={{
                    hidden: {opacity: 0, y: 30},
                    visible: {opacity: 1, y: 0, transition: {duration: 0.6}}
                }}>
                    {faq_items.map((e, idx) => <FaqItem key={idx} answer={e.answer} question={e.question}/>)}
                </motion.div>
                <motion.div className="bg_circles" variants={{
                    hidden: {opacity: 0, scale: 0.8},
                    visible: {opacity: 1, scale: 1, transition: {duration: 0.6}}
                }}>
                    <img alt="" src={circles_bg}/>
                </motion.div>
            </motion.div>


            <motion.div className="no_coding_block" initial={{opacity: 0, y: 50}} whileInView={{opacity: 1, y: 0}}
                        viewport={{once: true, amount: 0.3}} transition={{duration: 0.8}}>
                <div className="no_coding_content" initial={{opacity: 0}} animate={{opacity: 1}}
                            transition={{duration: 0.8}}>
                    <img src={waves_bg} alt="" className="waves_last"/>
                    <div className="powered_by_last">
                        <div className="circle"></div>
                        Powered by Undura Lite
                    </div>
                    <div className="no_coding_name">Join a transparent network <br/>of donors.</div>
                    <div className="no_coding_text">Create your profile and start supporting verified projects today.
                    </div>
                    <DevelopmentButton className="start_now_button_last pos_center_popup">
                        Join now
                    </DevelopmentButton>
                </div>
            </motion.div>
            <Footer mode = "lite"/>

        </div>
    );
};

export default ForDonors;